<div
  *ngIf="errorStateService.errorCount"
  id="mach-core-vacation-widget-error"
  class="vacation-widget__error flex justify-center tablet:mb-[24px]"
>
  <idp-error-message
    [errorMessage]="'To continue, please correct the'"
    [cntError]="errorStateService.errorCount"
    [firstErroneousElement]="errorStateService.firstErrorElement"
  ></idp-error-message>
</div>
<form
  id="mach-core-vacation-widget-form"
  [ngClass]="{
    'gap-[24px]': !viewSearchOptionExpanded
  }"
  class="vacation-widget__form !flex w-full flex-col items-center tablet:p-[2px] laptop:p-0 laptop:gap-[8px] ultrawide:gap-[12px] laptop:flex-row"
  [formGroup]="vacationWidgetForm"
  (ngSubmit)="formSubmit($event)"
>
  <div
    class="vacation-widget__airport-field relative flex-shrink mb-8 laptop:mb-0"
  >
    <div
      tabindex="0"
      class="vacation-widget__airport-input w-[343px] tablet:w-[520px] laptop:w-[239.33px] ultrawide:w-[292px]"
      [id]="content.fromAndToOption.id"
    ></div>
    <div
      *ngIf="hasErrorMessage"
      class="vacation-widget__error-space h-[22px] laptop:h-[32px] mt-[8px]"
    >
      <div
        *ngIf="errorStateService.airportErrorMessage"
        class="vacation-widget__error-message text-caption-medium text-alert"
      >
        {{ errorStateService.airportErrorMessage }}
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      hidden: viewSearchOptionExpanded
    }"
    id="mach-core-vacation-widget-view-options"
    class="vacation-widget__view-options flex justify-center laptop:hidden"
  >
    <idp-view-search-options
      (expand)="displayOptions(); $event.stopPropagation()"
      [label]="content.labels.viewSearchOptionsLabel"
    ></idp-view-search-options>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    id="vacation-widget__date-picker"
    class="vacation-widget__date-field flex-shrink laptop:block mb-8 laptop:mb-0"
  >
    <button
      type="button"
      [id]="content.dropDownDateOption.triggerElementId"
      [ngClass]="{
        'outline-2 outline-stroke-alert !outline':
          errorStateService.datesErrorMessage ||
          errorStateService.maxDatesErrorMessage
      }"
      class="vacation-widget__date-button flex h-[74px] w-[343px] cursor-pointer items-center justify-between rounded-02 border border-stroke-01 bg-surface-02 px-16 tablet:w-[520px] laptop:w-[194px] ultrawide:w-[212.67px]"
      (click)="openDatePicker(); $event.preventDefault()"
    >
      <div class="vacation-widget__date-content flex flex-col items-start">
        <div class="vacation-widget__date-label flex items-center gap-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            class="vacation-widget__date-icon text-icon-primary"
          >
            <path
              d="M13.165 1.68848C13.6922 1.6839 13.8291 2.15448 13.834 2.17188V3.14062C13.834 3.14062 15.6711 3.13597 16.2666 3.14062C16.8477 3.21239 16.875 3.68555 16.875 3.68555V14.6377C16.875 14.6377 16.9167 15.1499 15.9014 15.1826C13.3766 15.188 5.82211 15.1901 1.61133 15.1826C1.19801 15.1323 1.125 14.5771 1.125 14.5771V3.74609C1.125 3.74609 1.19012 3.15236 1.7334 3.14062C2.27219 3.12906 4.13174 3.14042 4.16504 3.14062V2.17188C4.16918 2.15813 4.32181 1.66566 4.83398 1.68848C5.34353 1.71144 5.49711 2.1545 5.50293 2.17188V3.14062H8.30078V2.17188C8.30483 2.15491 8.41982 1.69531 8.96973 1.68848C9.52083 1.68178 9.63518 2.15674 9.63867 2.17188V3.14062H12.4961V2.17188C12.4985 2.15639 12.5772 1.68787 13.165 1.68848ZM2.46387 13.8516H15.5381V7.49707H2.46387V13.8516ZM2.46387 6.16602H15.5381V4.47168H2.46387V6.16602Z"
              fill="currentColor"
            />
          </svg>
          <span
            id="max-range-date-display"
            class="vacation-widget__date-text text-heading text-label-md-medium"
          >
            {{ content.dropDownDateOption.title }}
          </span>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        class="vacation-widget__dropdown-icon text-icon-primary transition-transform duration-200"
        [ngClass]="{ 'rotate-180': isDatePickerOpen }"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6 9L0.75 3H11.25L6 9Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <div
      class="vacation-widget__date-picker date-picker"
      [id]="content.dropDownDateOption.id"
      (click)="$event.stopPropagation(); $event.preventDefault()"
    ></div>
    <div
      *ngIf="hasErrorMessage"
      class="vacation-widget__error-space h-[22px] laptop:h-[32px] mt-[8px]"
    >
      <div
        *ngIf="errorStateService.datesErrorMessage"
        class="vacation-widget__error-message text-caption-medium text-alert"
      >
        {{ errorStateService.datesErrorMessage }}
      </div>
      <div
        *ngIf="errorStateService.maxDatesErrorMessage"
        class="vacation-widget__error-message text-caption-medium text-alert"
      >
        {{ errorStateService.maxDatesErrorMessage }}
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    class="vacation-widget__passenger-field flex-shrink laptop:block mb-8 laptop:mb-0"
  >
    <div
      id="vacation-widget__passenger-selector"
      class="vacation-widget__passenger-selector relative w-[343px] tablet:w-[520px] laptop:w-[157.33px] laptop:text-ellipsis ultrawide:w-[212.67px]"
    >
      <button
        type="button"
        [ngClass]="{
          'outline-2 outline-stroke-alert !outline':
            errorStateService.tooFewPeopleErrorMessage
        }"
        class="vacation-widget__passenger-button dropdown relative h-[74px] w-full !border-stroke-01"
        [id]="content.dropDownPassengerOption.id"
      ></button>
    </div>
    <div
      *ngIf="hasErrorMessage"
      class="vacation-widget__error-space h-[22px] laptop:h-[32px] mt-[8px]"
    >
      <div
        *ngIf="errorStateService.tooFewPeopleErrorMessage"
        class="vacation-widget__error-message text-caption-medium text-alert"
      >
        {{ errorStateService.tooFewPeopleErrorMessage }}
      </div>
    </div>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    class="vacation-widget__room-field flex-shrink laptop:block mb-8 laptop:mb-0"
  >
    <div
      id="vacation-widget__room-selector"
      class="vacation-widget__room-selector dropdown relative w-[343px] tablet:w-[520px] laptop:w-[157.33px] ultrawide:w-[212.67px]"
    >
      <button
        type="button"
        class="vacation-widget__room-button dropdown h-[74px] w-full !border-stroke-01"
        [id]="content.dropDownRoomOption.id"
      ></button>
    </div>
    <div
      *ngIf="hasErrorMessage"
      class="vacation-widget__error-space hidden laptop:block h-[32px] mt-[8px]"
    ></div>
  </div>
  <!-- Certificates link: visible above search button on tablet/mobile -->
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    *ngIf="content.labels.certificatesLinkLabel"
    class="vacation-widget__link-field flex w-full my-8 justify-start laptop:hidden"
  >
    <a [href]="content.certificatesLink.url" class="link link-md">
      {{ content.labels.certificatesLinkLabel }}
    </a>
  </div>
  <div
    [ngClass]="{
      hidden: !viewSearchOptionExpanded
    }"
    class="vacation-widget__submit-field mt-24 flex-shrink laptop:mt-0 laptop:block"
  >
    <button
      #findVacationButtonElement
      type="submit"
      class="vacation-widget__submit-button button button-primary button-lg text-label-md-semibold w-[343px] laptop:w-[132px] ultrawide:w-[154px] tablet:w-[520px] h-[64px] rounded-[6px] whitespace-nowrap laptop:ml-[24px] ultrawide:ml-[32px]"
      [attr.aria-label]="content.accessibility.buttonAriaLabel"
      (click)="
        isIntentionalSubmit = true;
        analyticsEvent.emit(findVacationButtonElement)
      "
    >
      {{ content.labels.buttonLabel }}
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="vacation-widget__submit-icon"
      >
        <g clip-path="url(#clip0_15646_212187)">
          <path
            d="M12 0V8.80078H10.3994V2.65625L1.13184 12.002L0 10.8604L9.18359 1.60059H3.19824V0H12Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_15646_212187">
            <rect width="12" height="12" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    </button>
    <div
      *ngIf="hasErrorMessage"
      class="vacation-widget__error-space hidden laptop:block h-[32px] mt-[8px]"
    ></div>
  </div>
  <!-- Hidden form controls -->
  <input type="hidden" formControlName="originAirportCode" />
  <input type="hidden" formControlName="destinationAirportCode" />
  <input type="hidden" formControlName="departDate" />
  <input type="hidden" formControlName="returnDate" />
  <input type="hidden" formControlName="numberOfPassengers" />
  <input type="hidden" formControlName="numberOfRooms" />
</form>
<!-- Certificates link: visible below all inputs on laptop+ -->
<div
  *ngIf="content.labels.certificatesLinkLabel"
  class="vacation-widget__link-field-desktop hidden laptop:flex justify-end w-full mt-8 ultrawide:mt-12"
>
  <a [href]="content.certificatesLink.url" class="link link-md">
    {{ content.labels.certificatesLinkLabel }}
  </a>
</div>
